import { cloneDeep, isEmpty, isUndefined } from 'lodash';
import PropertyStatus from './PropertyStatus';
import { required, requiredIf } from 'vuelidate/lib/validators';

const isUndefinedOrEmpty = value => isUndefined(value) || isEmpty(value);

export const form = () => cloneDeep({
  propertyStatusId: {
    label: 'Property Status',
    type: 'select',
    value: '',
    disabled: false,
    trackBy: 'propertyStatusId',
    labelBy: 'status',
    options: [],
    columnOptions: {
      md: 12,
    },
    optionsFn: async () => {
      const { data } = await PropertyStatus.list();
      return data.data;
    },
    messages: [{
      type: 'warning',
      text: 'You must enable at least one compliance type',
      show: form => (form.propertyStatusId.value
        ? form.propertyStatusId.value.propertyStatusId === 1
        : false),
    }],
  },
  statusComment: {
    label: 'Status comment',
    type: 'text',
    value: '',
    disabled: false,
    columnOptions: {
      md: 12,
    },
    hidden: form => (form.propertyStatusId.value
      ? !form.propertyStatusId.value.requiresComment
      : true),
  },
  clientPropertyDesignation: {
    label: 'Client Property Designation',
    type: 'text',
    value: '',
  },
  propertyDesignation: {
    label: 'Riskhub Property Designation',
    type: 'text',
    value: '',
    disabled: true,
  },
  programme: {
    label: 'Programme',
    type: 'select',
    value: 'REG10 Door Programme',
    trackBy: 'programme',
    labelBy: 'programme',
    disabled: false,
    hidden: true,
    columnOptions: {
      md: 12,
    },
    options: [
      {
        programme: 'REG10 Door POW',
      },
      {
        programme: 'Annual Door POW',
      },
      {
        programme: 'Two Year Door POW',
      },
    ],
    messages: [{
      type: 'warning',
      text: 'You must select a programme',
      show: form => form.programme.value === '',
    }],
  },
});

export const validators = {
  propertyStatusId: {
    required,
  },
  statusComment: {
    requiredIf: requiredIf(function () {
      if (isUndefinedOrEmpty(this.$v.fields.propertyStatusId.value.$model)) {
        return false;
      }
      return this.$v.fields.propertyStatusId.value.$model.propertyStatusId !== 1;
    }),
  },
};
